import type { TableColumns } from '@ohpen/enso-ui';
import { ExclusivitySetDataRow, ExclusivitySetResponse, FieldType } from '@pmp/api';

export const exclusiveSetsColumns: TableColumns<ExclusivitySetResponse> = [
  {
    title: 'pmp.exclusiveProducts.labels.id',
    dataIndex: 'id',
    key: 'id',
    options: {
      filter: 'search',
      sorter: true,
      hide: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.name',
    dataIndex: 'name',
    key: 'name',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.description',
    dataIndex: 'description',
    key: 'description',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.startDate',
    dataIndex: 'startDate',
    key: 'startDate',
    options: {
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.endDate',
    dataIndex: 'endDate',
    key: 'endDate',
    width: 240,
    options: {
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.firmIds',
    dataIndex: 'lenderFirms',
    key: 'firmIds',
    options: {
      format: {
        type: 'multiValueListKey',
      },
      filter: 'select',
      listName: FieldType.FIRMS,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.firms',
    dataIndex: 'lenderFirms',
    key: 'firms',
    width: 140,
    options: {
      format: {
        type: 'multiValueList',
        ellipsis: { visibleItems: 1 },
      },
      filter: 'select',
      listName: FieldType.FIRMS,
      allowSearch: true,
    },
  },
  { title: 'global.labels.actions', dataIndex: '', key: 'actions', width: 100, fixed: 'right' },
];

// Change-request rows expose the firms as `firms` (ids), unlike the list response which uses `lenderFirms`.
export const exclusiveSetsCRColumns: TableColumns<ExclusivitySetDataRow> = [
  {
    title: 'pmp.exclusiveProducts.labels.id',
    dataIndex: 'id',
    key: 'id',
    options: {
      filter: 'search',
      sorter: true,
      hide: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.name',
    dataIndex: 'name',
    key: 'name',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.description',
    dataIndex: 'description',
    key: 'description',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.startDate',
    dataIndex: 'startDate',
    key: 'startDate',
    options: {
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.endDate',
    dataIndex: 'endDate',
    key: 'endDate',
    options: {
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.firmIds',
    dataIndex: 'firms',
    key: 'firmIds',
    options: {
      format: {
        type: 'multiValueListKey',
      },
      filter: 'select',
      listName: FieldType.FIRMS,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.firms',
    dataIndex: 'firms',
    key: 'firms',
    width: 240,
    options: {
      format: {
        type: 'multiValueList',
        ellipsis: { visibleItems: 1 },
      },
      filter: 'select',
      listName: FieldType.FIRMS,
      allowSearch: true,
      sortSelectedFirst: true,
    },
  },
  { title: 'global.labels.actions', dataIndex: '', key: 'actions', width: 100, fixed: 'right' },
];
